import { configureStore } from '@reduxjs/toolkit';
import showNavlinksReducer from './showNavlinksSlice.js';
import facilitiesReducer from '../facilitiesSlice.js';  // Import the facilities reducer

const store = configureStore({
  reducer: {
    showNavlinks: showNavlinksReducer,
    facilities: facilitiesReducer,  // Add the facilities reducer
  },
});

export default store;
